var _path, _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00037 0C5.55266 0 6.00037 0.447715 6.00037 1L6.00037 3.00016H14.0011L14.0011 1C14.0011 0.447715 14.4489 0 15.0011 0C15.5534 0 16.0012 0.447715 16.0011 1V3.0043C16.4992 3.01138 16.9443 3.03055 17.3292 3.0823C17.9847 3.17043 18.6131 3.36918 19.1228 3.87884C19.6324 4.3885 19.8312 5.01685 19.9193 5.67237C20.0015 6.28403 20.0015 7.04785 20.0014 7.93435L20.0014 8.00016V15.0014L20.0014 15.0672C20.0015 15.9537 20.0015 16.7176 19.9193 17.3292C19.8312 17.9847 19.6324 18.6131 19.1228 19.1228C18.6131 19.6324 17.9847 19.8312 17.3292 19.9193C16.7176 20.0015 15.9538 20.0015 15.0673 20.0014L15.0014 20.0014H5.00001L4.93415 20.0014C4.04767 20.0015 3.28387 20.0015 2.67221 19.9193C2.0167 19.8312 1.38835 19.6324 0.878684 19.1228C0.369022 18.6131 0.170277 17.9847 0.0821453 17.3292C-9.01857e-05 16.7176 -4.73896e-05 15.9538 2.43991e-06 15.0673L4.8241e-06 15.0014V8.00016L2.43991e-06 7.93433C-4.73896e-05 7.04784 -9.01857e-05 6.28403 0.0821454 5.67237C0.170277 5.01685 0.369022 4.3885 0.878684 3.87884C1.38835 3.36918 2.0167 3.17043 2.67221 3.0823C3.05713 3.03055 3.5023 3.01138 4.00037 3.00429L4.00037 1C4.00037 0.447715 4.44809 0 5.00037 0ZM2 8.0005V15.0014C2 15.9725 2.00213 16.6002 2.06431 17.0627C2.12263 17.4965 2.21677 17.6324 2.2929 17.7085C2.36902 17.7847 2.50497 17.8788 2.93871 17.9371C3.40122 17.9993 4.02893 18.0014 5.00001 18.0014H15.0014C15.9725 18.0014 16.6002 17.9993 17.0627 17.9371C17.4965 17.8788 17.6324 17.7847 17.7085 17.7085C17.7847 17.6324 17.8788 17.4965 17.9371 17.0627C17.9993 16.6002 18.0014 15.9725 18.0014 15.0014V8.0005H2Z",
    fill: "#B2B2B2"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.00049,
    y: 10.0005,
    width: 4.00032,
    height: 2.00017,
    rx: 0.5,
    fill: "#B2B2B2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.00049,
    y: 14.001,
    width: 4.00032,
    height: 2.00017,
    rx: 0.5,
    fill: "#B2B2B2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.001,
    y: 10.0005,
    width: 4.00032,
    height: 2.00017,
    rx: 0.5,
    fill: "#B2B2B2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 11.001,
    y: 14.001,
    width: 4.00032,
    height: 2.00017,
    rx: 0.5,
    fill: "#B2B2B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.87bcd825ac999d7d6361aa173aebdd0f.svg";
export { ForwardRef as ReactComponent };